import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { Lock, User } from 'lucide-react';
import { TextField, Button, Typography, Paper, Box, InputAdornment } from '@mui/material';
import './LoginPage.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const { showErrorToast, showSuccessToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      showErrorToast('Please enter both username and password');
      return;
    }
    
    setIsLoading(true);
    
    // Simulate network delay
    setTimeout(() => {
      const success = login(username, password);
      
      if (success) {
        showSuccessToast('Login successful');
        navigate('/admin');
      } else {
        showErrorToast('Invalid username or password');
      }
      
      setIsLoading(false);
    }, 1000);
  };

  return (
    <Box className="login-page" display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="var(--deep-space)" mt={{ xs: 2, sm: 4 }} px={{ xs: 2, sm: 0 }}>
      <Paper className="login-container" elevation={3} sx={{ padding: { xs: '1.5rem', sm: '2rem' }, borderRadius: '12px', maxWidth: '500px', width: '100%', bgcolor: 'var(--form-bg)' }}>
        <Typography variant="h4" component="h1" gutterBottom color="var(--neon-blue)" textAlign="center">Admin Login</Typography>
        <Typography variant="body1" gutterBottom color="var(--quantum-silver)" textAlign="center">Enter your credentials to access the admin panel</Typography>
        <form className="login-form" onSubmit={handleSubmit}>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={isLoading}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <User size={18} className="form-icon" />
                </InputAdornment>
              )
            }}
            sx={{ input: { color: 'var(--quantum-silver)' }, label: { color: 'var(--quantum-silver)' } }}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock size={18} className="form-icon" />
                </InputAdornment>
              )
            }}
            sx={{ input: { color: 'var(--quantum-silver)' }, label: { color: 'var(--quantum-silver)' } }}
          />
          <Button 
            type="submit" 
            variant="contained" 
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ marginTop: '1rem', bgcolor: 'var(--neon-blue)', color: 'var(--deep-space)' }}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginPage; 